import { PHONE_TYPE_MAP, PHONE_TYPES } from 'UI/components/organisms/PhoneNumbersForm/utils';

export const formatResponse = response => {
  const data = response?.data || [];
  return data.map(item => {
    const defaultPhone =
      item?.phones_for_list?.find(phoneItem => phoneItem?.is_default) || item?.phones_for_list?.[0];

    return {
      ...item,
      fullName: item?.full_name || `${item?.first_name || ''} ${item?.last_name || ''}`.trim(),
      phone: defaultPhone
        ? {
            value: defaultPhone?.phone,
            extension: defaultPhone?.extension,
            countryCode: defaultPhone?.country_code,
            countryCodeId: defaultPhone?.country_code_id,
            use: defaultPhone?.use,
            typeId: defaultPhone?.type_id,
            type: PHONE_TYPE_MAP[defaultPhone?.type_id] || PHONE_TYPES.Unknown,
            isDefault: defaultPhone?.is_default
          }
        : {}
    };
  });
};
